import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}

    .user-avatar {
        align-items: center;
    }

    .top-row {
        align-items: center;
        justify-content: space-between;
    }

    .settings-container {
        width: 100%;
        padding-top: 1em;
    }

    .avatar-error {
        color: red;
    }

    .nav-sensitivity {
        display: flex;
        width: 100%;
        align-items: center;
        gap: var(--flex-gap);
    }

    .nav-sensitivity sl-input {
        flex-grow: 1;
        flex-shrink: 1;
        width: 5em;
    }

    .nav-sensitivity sl-icon-button {
        font-size: 1.5em;
    }

    .footer-buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        gap: var(--flex-gap);
    }
`;
